import React from 'react';
import PropTypes from 'prop-types';
import Button from 'components/button';
import RichText from 'components/rich-text';
import Link from 'components/link';

import cn from 'classnames';

const Rss = ({ headerText, buttonText, info, url }) => (
  <React.Fragment>
    <div className={cn('rss-block')}>
      <div className={cn('rss-block__header')}>
        <h2>{headerText}</h2>
      </div>
      <div className={cn('rss-block__info')}>
        {info && <RichText {...info} />}
      </div>
      <Link
        theme={[Button.themes.primary, Button.themes.big]}
        useButtonStyles={true}
        url={url}
      >
        {buttonText}
      </Link>
    </div>
  </React.Fragment>
);

Rss.propTypes = {
  headerText: PropTypes.string,
  buttonText: PropTypes.string,
  info: PropTypes.exact(RichText.propTypes),
  url: PropTypes.string
};

export default Rss;
